define('TescoMobile_Catalog/js/catalog-add-to-cart-mixin',['jquery', 'TescoMobile_Checkout/js/model/insurance'], function ($, insuranceModel) {
  'use strict';

  return function (widget) {
    $.widget('mage.catalogAddToCart', widget, {
      _create: function () {
        this._super();
        this._initChoiceModalEvent();
      },
      _initChoiceModalEvent: function () {
        $(document).on('ajax:addToCart', function (e, data) {
          if ($('#tm-insurance-content').length && data.response && data.response.tm_quote) {
            insuranceModel.quoteItemId = data.response.tm_quote.item_id;
            insuranceModel.quoteMask = data.response.tm_quote.mask;
            $('#tm-insurance-content').modal('openModal');
          }
        }.bind(this));
      }
    });
    return widget;
  };
});

